import React from "react";

export class FieldGroupHeader extends React.PureComponent {
    render() {
        return <h5 className="text-center form-header">{this.props.children}</h5>;
    }
}